//Bibliotecas
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
//Componentes material
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { withStyles } from '@material-ui/core';
//Ícones material
import AddCircleIcon from '@material-ui/icons/AddCircle';
//Componentes
import Layout from './Layout';
import VitalizePaper from '../components/VitalizePaper';
import Secao from '../components/questionario/Secao';
import VitalizeFab from '../components/VitalizeFab';
//Úteis
import deepCopy from '../utils/deepCopy';
//Controllers
import QuestionarioController from '../controllers/QuestionarioController';
import PermissaoController from '../controllers/PermissaoController';
import EmpresaController from '../controllers/EmpresaController';
//Modelos
import Questionario, { STATUS_RASCUNHO, STATUS_PUBLICADO, STATUS_DESATIVADO } from '../models/Questionario';
import QuestionarioSecao from '../models/QuestionarioSecao';
import QuestionarioQuestao from '../models/QuestionarioQuestao';
import QuestionarioOpcaoResposta from '../models/QuestionarioOpcaoResposta';
import ErroQuestionario from '../models/ErroQuestionario';

const styles = (theme) => ({
    botaoSecao: {
        marginTop: theme.spacing(2)
    }
});

class QuestionarioFormPage extends React.Component {
    constructor(props) {
        super(props);
        //Controllers
        this.questionarioController = new QuestionarioController();
        this.permissaoController = new PermissaoController();
        this.empresaController = new EmpresaController();
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleSecaoChange = this.handleSecaoChange.bind(this);
        this.handleSecaoDelete = this.handleSecaoDelete.bind(this);
        this.handleSecaoMoveUp = this.handleSecaoMoveUp.bind(this);
        this.handleSecaoMoveDown = this.handleSecaoMoveDown.bind(this);
        this.handleAdicionarSecao = this.handleAdicionarSecao.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        //Estado inicial
        this.state = {
            sucesso: false,
            processando: false,
            carregando: true,
            focoAutomatico: false,
            permiteSelecionarEmpresa: false,
            permiteCadastrarQuestionario: false,
            empresas: [],
            valores: new Questionario(),
            erros: new ErroQuestionario()
        };
    }

    /**
     * Carrega os dados do questionário sendo editado
     */
    async componentDidMount() {
        const id = this.getId();
        const state = deepCopy(this.state);
        state.carregando = false; //Indica que a consulta terminou
        if (id > 0) {
            let result = { sucesso: false };
            if (this.getIsDuplicar())
                result = await this.questionarioController.duplicar(id);
            else
                result = await this.questionarioController.obter(id);
            if (result.sucesso) {
                state.valores = result.questionario;
            }
        } else {
            //Inicializa o questionário com uma seção e uma questão já adicionadas
            state.valores = new Questionario();
            const secao = new QuestionarioSecao();
            const questao = new QuestionarioQuestao();
            questao.opcoes = [new QuestionarioOpcaoResposta()];
            secao.questoes.push(questao);
            //Adiciona a seção no questionário
            state.valores.secoes.push(secao);
        }
        state.permiteCadastrarQuestionario = await this.permissaoController.permiteCadastrarQuestionario();
        state.permiteSelecionarEmpresa = await this.permissaoController.permiteSelecionarEmpresa();
        if (state.permiteSelecionarEmpresa)
            state.empresas = await this.obterEmpresas();

        this.setState(state);
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Somente se o usuário tiver permissão
        if (this.state.permiteCadastrarQuestionario) {
            //Cria uma cópia do estado atual
            const valores = Questionario.clone(this.state.valores);
            //Atualiza somente o valor do campo alterado
            valores[event.target.name] = event.target.value;
            //Atualiza o estado
            this.setState({ valores, focoAutomatico: true });
        }
    }

    /**
     * Trata as alterações nos checkbox
     * @param {*} event Objeto contendo os dados do vento
     */
    handleCheckboxChange(event) {
        //Cria uma cópia do estado atual
        const valores = Questionario.clone(this.state.valores);
        //Atualiza somente o valor do campo alterado
        valores[event.target.name] = event.target.checked;
        //Atualiza o estado
        this.setState({ valores, focoAutomatico: true });
    }

    /**
     * Trata a submissão do formulário
     * @param {*} event Objeto contendo o evento
     */
    handleFormSubmit(event) {
        event.preventDefault();
        if (this.state.permiteCadastrarQuestionario)
            this.salvarQuestionario();
    }

    /**
     * Trata as alterações nas seções
     * @param {QuestionarioSecao} secao Objeto de seção do questionário que foi alterado
     */
    handleSecaoChange(secao) {
        //Cria uma cópia do estado atual
        const valores = Questionario.clone(this.state.valores);
        //Identifica o índice da seção
        const indice = valores.secoes.findIndex(s => s.ordem === secao.ordem);
        //Atualiza o valor na lista
        valores.secoes[indice] = secao;
        //Atualiza o estado da página
        this.setState({ valores, focoAutomatico: true });
    }

    /**
     * Trata o evento de movimentação da seção para cima
     * @param {QuestionarioSecao} secao Objeto de seção do questionário que foi movimentado
     */
    handleSecaoMoveUp(secao) {
        //Copia o estado
        let valores = Questionario.clone(this.state.valores);
        //Identifica o índice da seção alterada
        const indice = valores.secoes.findIndex(s => s.ordem === secao.ordem);
        //Verifica se já não é a primeira
        if (indice > 0) {
            //Troca a posição da seção com a anterior
            valores = this.trocarSecoes(valores, indice, indice - 1);
            //Atualiza o estado
            this.setState({ valores, focoAutomatico: true });
        }
    }

    /**
     * Trata o evento de movimentação da seção para baixo
     * @param {*} secao Objeto de seção do questionário que foi movimentado
     */
    handleSecaoMoveDown(secao) {
        //Copia o estado
        let valores = Questionario.clone(this.state.valores);
        //Identifica o índice da seção alterada
        const indice = valores.secoes.findIndex(s => s.ordem === secao.ordem);
        //Verifica se já não é a última
        if (indice < valores.secoes.length - 1) {
            //Troca a posição da seção com a anterior
            valores = this.trocarSecoes(valores, indice, indice + 1);
            //Atualiza o estado
            this.setState({ valores, focoAutomatico: true });
        }
    }

    /**
     * Trata o evento de exclusão da seção
     * @param {QuestionarioSecao} secao Objeto contendo a seção a ser excluída
     */
    handleSecaoDelete(secao) {
        //Cria uma cópia do estado atual
        const valores = Questionario.clone(this.state.valores);
        //Retorna a lista sem a seção excluída
        valores.secoes = valores.secoes.filter(s => s.ordem !== secao.ordem);
        //Atualiza o estado da página
        this.setState({ valores, focoAutomatico: true });
    }

    /**
     * Trata o click no botão para adicionar novas seções
     */
    handleAdicionarSecao() {
        //Cria uma cópia do estado atual
        const valores = Questionario.clone(this.state.valores);

        //Identifica o último ID inserido
        let ultimaOrdem = 0;
        if (valores.secoes.length > 0)
            ultimaOrdem = Math.max(...valores.secoes.map(s => s.ordem));

        //Inicializa uma nova seção com uma questão em branco
        const secao = new QuestionarioSecao(null, '', ultimaOrdem + 1);
        secao.questoes.push(new QuestionarioQuestao());
        secao.questoes[0].opcoes = [new QuestionarioOpcaoResposta()];
        //Adiciona uma nova seção na lista
        valores.secoes.push(secao);
        //Atualiza o estado da página
        this.setState({ valores, focoAutomatico: true });
    }

    /**
     * Envia os dados do questionário para a API
     */
    async salvarQuestionario() {
        //Exibe loader
        this.setState({ processando: true });
        //Recupera o id da alteração
        const id = this.getId();
        //Monta o objeto que será repassado para o controller
        let result;
        //Chama a gravação no controller
        if (id === 0 || this.getIsDuplicar())
            result = await this.questionarioController.salvar(this.state.valores);
        else {
            const questionario = this.state.valores;
            questionario.id = id;
            result = await this.questionarioController.atualizar(questionario);
        }

        const state = deepCopy(this.state);
        state.processando = false; //Indica que o processamento terminou
        if (!result.sucesso) {
            //Atualiza o estado com os erros recebidos
            state.erros = result.erros;
        } else {
            //Atualiza o status do sucesso
            state.sucesso = true;
        }
        this.setState(state);
    }

    /**
     * Carrega as empresas da API
     */
    async obterEmpresas() {
        const result = await this.empresaController.listarSelecao();
        if (result.sucesso)
            return result.items;
        else
            return [];
    }

    /**
     * Recupera o Id do cliente a ser editado dos parâmetros da URL
     */
    getId() {
        let id;
        if (this.props.match)
            id = this.props.match.params.id;
        if (id === 'add')
            return 0;
        else
            return parseInt(id);
    }

    /**
     * Retorna verdadeiro se o formulário está realizando uma cópia de um questionário
     * Verifica pela URL
     * @returns {Boolean} Retorna verdadeiro caso seja para duplicar um questionário
     */
    getIsDuplicar() {
        const parts = this.props.match.path.split('/');
        return (parts.length === 4 && parts[3] === 'copia');
    }

    /**
     * Troca a posição de duas seções na lista do questionário
     * @param {Questionario} valores Objeto contendo o estado da página
     * @param {Number} indice1 Um dos índices a ser trocado
     * @param {Number} indice2 Outro índice a ser trocado
     * @returns {Questionario} Retorna o estado alterado
     */
    trocarSecoes(valores, indice1, indice2) {
        //Armazena as seções
        const s1 = valores.secoes[indice1];
        const s2 = valores.secoes[indice2];
        //Realiza a troca
        valores.secoes[indice2] = s1;
        valores.secoes[indice1] = s2;
        //Retorna o estado alterado
        return valores;
    }

    /**
     * Renderiza a mensagem de erro referete à lista de seções
     * @param {*} erros Mensagens de erro do questionário
     */
    renderizarMesagemErro(erros) {
        if (erros.erroSecoes) {
            return (
                <Grid item xs >
                    <FormHelperText id="secoes-helper" error={!!erros.erroSecoes}>{erros.erroSecoes}</FormHelperText>
                </Grid>
            );
        }
    }

    /**
     * Mapeia a lista de empresas para itens de seleção
     * @param {Array} empresas Empresas retornados pela API
     * @returns {Array<React.Component>} Retorna uma lista de componentes React
     */
    renderEmpresas(empresas) {
        return empresas.map(empresa => (
            <option key={empresa.id} value={empresa.id}>{empresa.cpfCnpj} - {empresa.nome}</option>
        ));
    }

    /**
     * Renderiza o campo de seleção de empresa, caso o usuário possua permissão 
     * @param {Boolean} permiteSelecionarEmpresa Indica se o usuário pode selecionar uma empresa
     * @param {String} empresa Valor selecionado
     * @param {String} empresaErro Mensagem de erro do campo
     * @param {Array} empresas Lista de empresas retornadas da API
     * @returns {React.Component} Retorna o componente ou null
     */
    renderCampoEmpresas(permiteSelecionarEmpresa, empresa, empresaErro, empresas) {
        if (permiteSelecionarEmpresa)
            return (
                <Grid item xs={12} sm={8} >
                    <FormControl fullWidth variant="outlined" error={!!empresaErro} >
                        <InputLabel htmlFor="empresa">Empresa</InputLabel>
                        <Select
                            id="empresa"
                            name="empresa"
                            label="Empresa"
                            native
                            variant="outlined"
                            fullWidth
                            value={empresa}
                            onChange={this.handleChange}
                        >
                            <option></option>
                            {this.renderEmpresas(empresas)}
                        </Select>
                        <FormHelperText id="empresa-helper">{empresaErro}</FormHelperText>
                    </FormControl>
                </Grid>
            );
        else
            return null;
    }

    /**
     * Renderiza o campo de indicação de modelo, caso o usuário possua permissão
     * @param {Boolean} permiteSelecionarEmpresa Indica se o usuário pode selecionar uma empresa
     * @param {Boolean} modelo Valor do campo
     * @param {String} modeloErro Mensagem de erro do campo
     * @return {React.Component} Retorna o componente ou null
     */
    renderCampoModelo(modelo, modeloErro) {
        return (
            <Grid item xs={4} sm={2}>
                <FormControl fullWidth variant="standard" error={!!modeloErro} >
                    <FormControlLabel
                        id="modelo-label"
                        control={
                            <Checkbox
                                checked={modelo}
                                onChange={this.handleCheckboxChange}
                                name="modelo"
                                color="primary"
                            />
                        }
                        label="Modelo"
                    />
                    <FormHelperText id="modelo-helper" >{modeloErro}</FormHelperText>
                </FormControl>
            </Grid>
        );
    }

    /**
     * Renderiza o campo de seleção de status do questionário
     * @param {Boolean} permiteSelecionarStatus Indica se o campo status estará visível
     * @param {String} status Valor do campo 
     * @param {String} statusErro Mensagem de erro do campo
     * @return {React.Component} Retorna o componente ou null
     */
    renderCampoStatus(permiteSelecionarStatus, status, statusErro) {
        if (permiteSelecionarStatus)
            return (
                <Grid item xs={6} sm={2}>
                    <FormControl fullWidth variant="outlined" error={!!statusErro} >
                        <InputLabel htmlFor="status">Status</InputLabel>
                        <Select
                            id="status"
                            name="status"
                            label="Status"
                            native
                            variant="outlined"
                            fullWidth
                            value={status}
                            onChange={this.handleChange}
                        >
                            <option value={STATUS_RASCUNHO}>Rascunho</option>
                            <option value={STATUS_PUBLICADO}>Publicado</option>
                            <option value={STATUS_DESATIVADO}>Desativado</option>
                        </Select>
                        <FormHelperText id="status-helper">{statusErro}</FormHelperText>
                    </FormControl>
                </Grid>
            );
        else
            return null;
    }

    /**
     * Renderiza o campo de indicando se o questionário pode ser visualizado pelo cliente
     * @param {Boolean} permiteIndicarExibeCliente Indica se o usuario pode alterar a opção
     * @param {Boolean} exibeCliente Valor do campo
     * @param {String} exibeClienteErro Mensagem de erro do campo
     * @return {React.Component} Retorna o componente ou null
     */
    renderCampoExibeCliente(permiteIndicarExibeCliente, exibeCliente, exibeClienteErro) {
        if (permiteIndicarExibeCliente)
            return (
                <Grid item xs={6} sm={2}>
                    <FormControl fullWidth variant="standard" error={!!exibeClienteErro} >
                        <FormControlLabel
                            id="exibeCliente-label"
                            control={
                                <Checkbox
                                    checked={exibeCliente}
                                    onChange={this.handleCheckboxChange}
                                    name="exibeCliente"
                                    color="primary"
                                />
                            }
                            label="Visível formando"
                        />
                        <FormHelperText id="exibeCliente-helper" >{exibeClienteErro}</FormHelperText>
                    </FormControl>
                </Grid>
            );
        else
            return null;
    }

    /**
     * Renderiza o botão salvar, caso o usuário possua permissão para o cadastro
     * @param {Boolean} permiteCadastrarQuestionario Permissão do usuário para cadastrar o questionário
     * @param {Boolean} processando Indica se o componente está processando
     * @returns {React.Component} Retorna o componente ou null
     */
    renderBotaoSalvar(permiteCadastrarQuestionario, processando) {
        if (permiteCadastrarQuestionario)
            return (
                <VitalizeFab variant="contained" color="primary" type="submit" loading={processando} >
                    Salvar
                </VitalizeFab>
            );
        else
            return null;
    }

    render() {
        const { onLogout, classes, usuario, empresa: empresaLogin, permissoes } = this.props;

        const {
            sucesso,
            empresas,
            permiteSelecionarEmpresa,
            permiteCadastrarQuestionario,
            focoAutomatico,
            processando,
            carregando
        } = this.state;

        const {
            titulo,
            modelo,
            empresa,
            secoes,
            status,
            exibeCliente
        } = this.state.valores;

        const {
            titulo: tituloErro,
            modelo: modeloErro,
            secoes: secoesErro,
            empresa: empresaErro,
            status: statusErro,
            exibeCliente: exibeClienteErro
        } = this.state.erros;

        if (sucesso) return (<Redirect to="/questionario" />);

        return (
            <Layout onLogout={onLogout} returnLink="/questionario" usuario={usuario} empresa={empresaLogin} permissoes={permissoes} carregando={carregando} >
                <form onSubmit={this.handleFormSubmit} noValidate >
                    <VitalizePaper>
                        <Grid container spacing={1}>
                            <Grid item xs={8} sm={10} >
                                <TextField
                                    name="titulo"
                                    label="Questionário"
                                    type="text"
                                    placeholder="Título do questionário"
                                    required
                                    variant="outlined"
                                    fullWidth
                                    autoFocus
                                    error={!!tituloErro}
                                    helperText={tituloErro}
                                    value={titulo}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            {this.renderCampoModelo(modelo, modeloErro)}
                            {this.renderCampoEmpresas(permiteSelecionarEmpresa, empresa, empresaErro, empresas)}
                            {this.renderCampoStatus(!modelo, status, statusErro)}
                            {this.renderCampoExibeCliente(!modelo, exibeCliente, exibeClienteErro)}
                        </Grid>
                        {this.renderizarMesagemErro(this.state.erros)}
                    </VitalizePaper>
                    {
                        secoes.map((secao, indice) => (
                            <Secao
                                key={secao.ordem}
                                secao={secao}
                                erros={secoesErro[indice]}
                                focoAutomatico={focoAutomatico}
                                readOnly={!permiteCadastrarQuestionario}
                                onChange={this.handleSecaoChange}
                                onDelete={this.handleSecaoDelete}
                                onMoveUp={this.handleSecaoMoveUp}
                                onMoveDown={this.handleSecaoMoveDown}
                            />
                        ))
                    }
                    {
                        permiteCadastrarQuestionario &&
                        <div>
                            <Button
                                id="adicionar-secao"
                                startIcon={<AddCircleIcon />}
                                fullWidth
                                color="secondary"
                                className={classes.botaoSecao}
                                onClick={this.handleAdicionarSecao}
                            >
                                Adicionar seção
                            </Button>
                        </div>

                    }
                    {this.renderBotaoSalvar(permiteCadastrarQuestionario, processando)}
                </form>
            </Layout>
        );
    }
}

QuestionarioFormPage.propTypes = {
    /** Evento disparado quando o usuário realiza o logout */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
    /** Parâmetros da URL */
    match: PropTypes.shape({
        /** Camiho da URL acessada pelo usuário */
        path: PropTypes.string,
        params: PropTypes.shape({
            /** Id do cliente a ser editado */
            id: PropTypes.string
        })
    }),
    /** Classes CSS da página */
    classes: PropTypes.shape({
        botaoSecao: PropTypes.string
    })
};

export default withStyles(styles)(QuestionarioFormPage);